export const fontFamily = {
  sans: 'DM Sans, sans-serif',
  mono: 'DM Mono, monospace',
};

export const typography = {
  fontFamily,
};
